import React from 'react';
export function SectionDivider() {
  return <div className="w-full flex items-center justify-center py-4 px-4 opacity-80" data-id="element-290">
      <div className="h-[1px] w-full max-w-[120px] bg-brand-gold/30" data-id="element-291"></div>
      <span className="text-brand-gold/60 text-[10px] mx-4" data-id="element-292">◆</span>
      <div className="h-[1px] w-full max-w-[120px] bg-brand-gold/30" data-id="element-293"></div>
    </div>;
}